"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _util = require("../../../util");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var base = function base(theme) {
  return /*#__PURE__*/(0, _react.css)("line-height:0;transition:transform 150ms ease-in-out;width:", (0, _util.rem)(48), ";height:", (0, _util.rem)(48), ";&&:before{border-radius:0;}svg{width:", theme.spacing[10], ";height:", theme.spacing[10], ";}&:hover{color:", theme.color.globalNav.iconActiveBasic, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

var collapsed = process.env.NODE_ENV === "production" ? {
  name: "1e2n1ip",
  styles: "&& svg{transform:rotate3d(0, 0, 1, -90deg);transition:all 75ms ease-in-out;}"
} : {
  name: "1ri0tol-collapsed",
  styles: "&& svg{transform:rotate3d(0, 0, 1, -90deg);transition:all 75ms ease-in-out;};label:collapsed;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var styles = {
  base: base,
  collapsed: collapsed
};
exports.styles = styles;
//# sourceMappingURL=MenuButton.styles.js.map